import store from '@state/store'
import { lazyLoadView } from '@utils/app/lazy-load-routes'
import { setInfo } from '@utils/app/select-info'
import toggle from '@utils/design/toggle-info'

export default [
  {
    path: '/actions',
    name: 'Actions',
    component: () => lazyLoadView(import('@views/actions/actions')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        store
          .dispatch('actions/fetchActions', {
            userId: store.getters['auth/currentUserId'],
          })
          .then(() => {
            store.dispatch('infoDetails/selectDetailsDefault', {
              defaultObject: null,
            })
            store.dispatch('info/setInfo', setInfo(routeTo.name))

            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },
]
